/**
 * @name SessionRecoveryLoading
 * @description Componente de loading para recuperação de sessão do operador
 * @author Keven Adan Bezerra | kevenadanb
 * @package src/components/common/SessionRecoveryLoading.tsx
 */

import { Box, CircularProgress, Typography } from "@mui/material";
import React from "react";

const SessionRecoveryLoading: React.FC = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        gap: 3,
        bgcolor: "background.default",
      }}
    >
      <CircularProgress
        size={60}
        thickness={4}
        sx={{
          color: "primary.main",
        }}
      />

      <Typography
        variant="h6"
        color="text.secondary"
        sx={{
          fontWeight: 500,
          textAlign: "center",
        }}
      >
        🔄 Verificando sessão do operador...
      </Typography>

      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          opacity: 0.7,
          textAlign: "center",
          maxWidth: 400,
        }}
      >
        Restaurando sua sessão anterior para continuar usando o totem
      </Typography>
    </Box>
  );
};

export default SessionRecoveryLoading;
